<div class="modal-header"><h2 class="modal-title">Part Lookup</h2></div>
<div class="modal-body">
    <div *ngIf="true">
        <div class="m-1">
            <dx-data-grid
                height="700"
                [dataSource]="items"
                [columnAutoWidth]="false"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onExporting)="onExporting($event)"
            >
                <dxi-column dataField="id"></dxi-column>
                <dxi-column dataField="subId"></dxi-column>
                <dxi-column dataField="date" caption="Created Date" dataType="date" format="shortDate" alignment="left"></dxi-column>
                <dxi-column dataField="user" caption="User" alignment="left"></dxi-column>
                <dxi-column dataField="detail" alignment="left" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="type" alignment="left"></dxi-column>
                <dxi-column dataField="quantity" alignment="left"></dxi-column>
                <dxi-column dataField="isAssembly"></dxi-column>
                <dxi-column dataField="description"></dxi-column>
                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="goToDetailDialog(cell.data.url)">{{ cell.value || '(blank)' }}</a>
                </div>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                <dxo-export [enabled]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-lookup-search-grid"></dxo-state-storing>
            </dx-data-grid>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
